<template>
  <div class="g-wrap">
    <div id="google-btn"></div>
    <div class="g-overlay">
      <button class="s-btn" type="button">
        <span class="s-icon"><GoogleLogo /></span>
        <span class="s-label">Continue with Google</span>
      </button>
    </div>
  </div>
</template>

<script>
import { afterAuthPath } from '@/http/requests/billing';
import constants from '../../../../../constant';
import GoogleLogo from '@/decast/icons/GoogleLogo.vue';

export default {
  name: 'GoogleLogin',
  components: {
    GoogleLogo,
  },
  mounted() {
    if (window.google) {
      google.accounts.id.initialize({
        client_id: constants.googleLoginKey,
        callback: this.handleCredentialResponse,
        auto_select: false,
        ux_mode: 'popup',
      });

      google.accounts.id.renderButton(document.getElementById('google-btn'), {
        theme: 'outline',
        size: 'large',
        type: 'standard',
        width: '100%',
      });
    }
  },
  methods: {
    handleCredentialResponse(response) {
      const token = response.credential;
      const payload = { token };
      document.getElementById('loading-bg-transparent-title').innerText =
        'Logging in with Google';
      document.getElementById('loading-bg-transparent').style.display = 'flex';
      this.$store
        .dispatch('auth/v2loginWithGoogle', payload)
        .then((res) => {
          const isTwoFactorAuthEnabled = res.data?.twoFactorAuthentication;
          if (isTwoFactorAuthEnabled) {
            const twoFactorToken = res.data?.token;
            this.$router.push({
              name: 'TwoFactor',
              query: { tempToken: twoFactorToken },
            });
          } else {
            this.$store.commit('auth/SET_LOGGEDIN', true);
            this.$acl.change('user');
            this.$vs.notify({
              title: 'Login Successful',
              text: 'Redirecting to dashboard!',
              iconPack: 'feather',
              icon: 'icon-check-circle',
              color: 'success',
            });
            this.$router.push(afterAuthPath('/dashboard/rooms'));
          }
        })
        .catch((error) => {
          const errorResponse = error.response?.data;
          let message = 'An error occurred.';
          if (errorResponse?.errors?.email) {
            message = 'Account does not exist!';
          } else if (errorResponse?.errors?.password) {
            message = 'Incorrect password, Please try again!';
          } else if (typeof errorResponse?.errors === 'string') {
            message = errorResponse.errors;
          }
          this.$vs.notify({
            title: 'Login Failed',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        })
        .finally(() => {
          document.getElementById('loading-bg-transparent').style.display =
            'none';
        });
    },
  },
};
</script>

<style scoped>
.g-wrap {
  position: relative;
  width: 100%;
  height: 42px;
}

#google-btn {
  position: absolute;
  inset: 0;
  z-index: 1;
  opacity: 0.001;
  overflow: hidden;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.g-overlay {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
}

.s-btn {
  width: 100%;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  color: #cdcfe0;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Rethink Sans', sans-serif;
  cursor: pointer;
  transition: border-color 0.15s, background-color 0.15s;
  padding: 0;
}

.g-wrap:hover .s-btn {
  border-color: rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.06);
}

.s-btn:active {
  transform: scale(0.98);
}

.s-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.s-icon svg {
  width: 18px;
  height: 18px;
}

.s-label {
  line-height: 1;
}
</style>
